/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Popular_TitleInputs */

const en_help_popular_title = /** @type {(inputs: Help_Popular_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular articles`)
};

const pl_help_popular_title = /** @type {(inputs: Help_Popular_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej czytane`)
};

/**
* | output |
* | --- |
* | "Popular articles" |
*
* @param {Help_Popular_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_popular_title = /** @type {((inputs?: Help_Popular_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Popular_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_popular_title(inputs)
	return en_help_popular_title(inputs)
});